import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaShieldAlt } from 'react-icons/fa';

const TermsAndConditions = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-purple-50">
            {/* Header */}
            <header className="bg-white shadow-sm border-b border-gray-200">
                <div className="container mx-auto px-4 py-4">
                    <Link to="/" className="inline-flex items-center text-pink-600 hover:text-pink-700 font-semibold transition-colors">
                        <FaArrowLeft className="mr-2" />
                        Back to Home
                    </Link>
                </div>
            </header>

            {/* Content */}
            <div className="container mx-auto px-4 py-12 max-w-4xl">
                <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
                    {/* Title */}
                    <div className="flex items-center mb-8">
                        <FaShieldAlt className="text-4xl text-pink-600 mr-4" />
                        <div>
                            <h1 className="text-4xl font-black text-gray-900">Terms & Conditions</h1>
                            <p className="text-gray-600 mt-1">Last updated: December 4, 2025</p>
                        </div>
                    </div>

                    {/* Content Sections */}
                    <div className="space-y-8 text-gray-700">
                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                            <p className="leading-relaxed">
                                By accessing and using SoulMate matrimony service, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Use License</h2>
                            <p className="leading-relaxed mb-3">
                                Permission is granted to temporarily use SoulMate for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Modify or copy the materials</li>
                                <li>Use the materials for any commercial purpose or public display</li>
                                <li>Attempt to reverse engineer any software contained on SoulMate</li>
                                <li>Remove any copyright or other proprietary notations from the materials</li>
                                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. User Accounts</h2>
                            <p className="leading-relaxed mb-3">
                                When you create an account with us, you must provide accurate, complete, and current information. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account.
                            </p>
                            <p className="leading-relaxed">
                                You are responsible for safeguarding the password that you use to access the service and for any activities or actions under your password.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Profile Information</h2>
                            <p className="leading-relaxed mb-3">
                                Users must ensure that all profile information is accurate and truthful. SoulMate reserves the right to:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Verify the authenticity of profiles</li>
                                <li>Remove or suspend profiles with false information</li>
                                <li>Request additional verification documents</li>
                                <li>Share verified information with potential matches</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Prohibited Activities</h2>
                            <p className="leading-relaxed mb-3">
                                Users are strictly prohibited from:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Harassing, abusing, or threatening other users</li>
                                <li>Creating fake or duplicate profiles</li>
                                <li>Sharing contact information of other users without consent</li>
                                <li>Using the platform for commercial solicitation</li>
                                <li>Posting inappropriate or offensive content</li>
                                <li>Attempting to scam or defraud other users</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Payment and Refunds</h2>
                            <p className="leading-relaxed mb-3">
                                Premium membership fees are non-refundable except as required by law. All payments are processed securely through our payment partners. By purchasing a premium membership, you agree to:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Pay all applicable fees and charges</li>
                                <li>Provide accurate payment information</li>
                                <li>Accept automatic renewal unless cancelled</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Disclaimer</h2>
                            <p className="leading-relaxed">
                                SoulMate is a platform to facilitate introductions between individuals seeking matrimonial alliances. We do not guarantee matches or marriages. Users are responsible for their own decisions and interactions. We are not liable for any outcomes resulting from connections made through our platform.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Limitation of Liability</h2>
                            <p className="leading-relaxed">
                                In no event shall SoulMate or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on SoulMate.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Privacy</h2>
                            <p className="leading-relaxed">
                                Your use of SoulMate is also governed by our Privacy Policy. Please review our Privacy Policy, which also governs the site and informs users of our data collection practices.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Changes to Terms</h2>
                            <p className="leading-relaxed">
                                We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the platform. Continued use of the service after changes constitutes acceptance of the new terms.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Contact Information</h2>
                            <p className="leading-relaxed">
                                If you have any questions about these Terms and Conditions, please contact us at:
                            </p>
                            <div className="mt-4 p-4 bg-pink-50 rounded-lg">
                                <p className="font-semibold">Email: Support@kalyanamatrimony.com</p>
                                <p className="font-semibold">Phone: +91 744-8539858</p>
                                <p className="font-semibold">Address: 573, Softye Technologies, Mettur main road, Ammapettai - Erode</p>
                            </div>
                        </section>
                    </div>

                    {/* Footer */}
                    <div className="mt-12 pt-8 border-t border-gray-200 text-center">
                        <p className="text-gray-600">
                            By using SoulMate, you acknowledge that you have read and understood these Terms and Conditions.
                        </p>
                        <Link to="/" className="inline-block mt-4 px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-500 text-white font-semibold rounded-lg hover:shadow-lg transition-all">
                            I Agree & Continue
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
